<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card>
        <b-row class="mb-3">
          <b-col cols="6" class="mt-1">
            <h4>{{ 'users_list_title' | translate('global') }}</h4>
          </b-col>
          <b-col cols="6">
            <div class="pull-right">
              <b-button variant="primary" class="mt-1" :disabled="isCreateDisabled" :to="{ name: 'UserCreate' }">
                <i class="fa fa-plus mr-2"></i>{{ 'add_new' | translate('global') }}
              </b-button>
            </div>
          </b-col>
        </b-row>
        <div v-if="spinners.contentIsLoading" class="text-center">
          <b-spinner type="grow" variant="primary"/>
        </div>
        <div v-else>
          <b-row>
            <b-col cols="12">
              <b-table class="table-sm text-center" responsive bordered :fields="tableFields" :items="tableItems">
                <template v-slot:is_active="row">
                  <b-badge v-if="row.item.is_active" variant="success">
                    {{ 'active' | translate('global') }}
                  </b-badge>
                  <b-badge v-if="!row.item.is_active" variant="secondary">
                    {{ 'inactive' | translate('global') }}
                  </b-badge>
                </template>
                <template v-slot:options="row">
                  <b-spinner v-if="spinners.isSaving === row.item.id"
                             type="grow" variant="primary" class="mr-3" small/>
                  <span v-if="spinners.isSaving">
                      <a v-if="!row.item.is_active && spinners.isSaving !== row.item.id" class="mr-3">
                        <i class="fa fa-unlock-alt fa-lg fa-secondary-disabled"/>
                      </a>
                      <a v-if="row.item.is_active && spinners.isSaving !== row.item.id" class="mr-3">
                        <i class="fa fa-ban fa-lg fa-secondary-disabled"/>
                      </a>
                    </span>
                  <span v-else>
                      <a v-if="!row.item.is_active && spinners.isSaving !== row.item.id" class="mr-3"
                         @click="changeUserActive(row.item.id, true)">
                        <i class="fa fa-unlock-alt fa-lg fa-success"/>
                      </a>
                      <a v-if="row.item.is_active && spinners.isSaving !== row.item.id" class="mr-3"
                         @click="changeUserActive(row.item.id, false)">
                        <i class="fa fa-ban fa-lg fa-danger"/>
                      </a>
                    </span>
                  <router-link :to="{ name: 'UserUpdate', params:{id: row.item.id}}">
                    <a><i class="fa fa-edit fa-lg"/></a>
                  </router-link>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <!--Paginator-->
            <b-col cols="12" v-if="tableItems.length">
              <Pagination :data="listPaginator" :limit="5" @pagination-change-page="onPageChange"/>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import statuses from '@/store/statuses';
import { mapGetters, mapActions } from 'vuex';
import Pagination from 'laravel-vue-pagination';
import VuexTypes from '@/store/types/index';

const UsersTypes = VuexTypes.users;
export default {
  mounted() {
    this.getData();
  },
  props: ['page'],
  data() {
    return {
      spinners: {
        contentIsLoading: true,
        isSaving: false
      },
      isCreateDisabled: true,
      tableFields: [
        { key: 'id', label: this.$t('id', 'global') },
        { key: 'name', label: this.$t('name', 'global') },
        { key: 'surname', label: this.$t('surname', 'global') },
        { key: 'email', label: this.$t('email', 'global') },
        { key: 'created_at', label: this.$t('created_at', 'global') },
        { key: 'updated_at', label: this.$t('updated_at', 'global') },
        { key: 'is_active', label: this.$t('active', 'global') },
        { key: 'options', label: this.$t('options', 'global')}
      ],
      tableItems: [],
    };
  },
  components: {
    Pagination
  },
  computed: {
    ...mapGetters('Users', [
      'usersList',
      'userUpdateActive'
    ]),
    listPaginator() {
      return this.usersList.data.meta;
    },
    list() {
      return this.usersList;
    }
  },
  watch: {
    page: 'getData',
    listPaginator: {
      handler: function () {
        if (this.listPaginator && this.listPaginator.last_page < this.page) {
          this.onPageChange(this.listPaginator.last_page);
        }
      },
      deep: true
    },
    list: {
      handler: function () {
        if (this.list['status'] === statuses.LOADED) {
          const data = this.list.data;
          this.tableItems = data.data || [];
          this.spinners.contentIsLoading = false;
          const actions = data ? data['actions'] : data['actions'];
          this.isCreateDisabled = !actions['create'];
        }
      },
      deep: true
    },
    userUpdateActive: {
      handler: function () {
        this.spinners.isSaving = false;
        if (this.userUpdateActive.status === statuses.LOADED) {
          this.alertSuccess();
          this.getData();
        } else if (this.userUpdateActive.status === statuses.ERROR) {
          this.alertError();
        }
      },
      deep: true
    },
  },
  methods: {
    ...mapActions('Users', [
      UsersTypes.USERS_LIST,
      UsersTypes.USER_UPDATE_ACTIVE,
    ]),
    getData() {
      this.USERS_LIST(this.page);
    },
    onPageChange(page) {
      if (!page) {
        page = this.page;
      }
      if (page !== this.page) {
        this.$router.push({ name: 'Users', params: { page } });
      }
    },
    changeUserActive(id, isActive) {
      this.spinners.isSaving = id;
      this.USER_UPDATE_ACTIVE({ id, isActive });
    }
  }
};
</script>
